import { Component, Input } from '@angular/core';

import { SideBarContent } from './';

@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],
    standalone: false
})
export class SideBarComponent {
  @Input() dynamicContent: SideBarContent;
  readonly SideBarContentEnum = SideBarContent;
}
